import { useState, useEffect, useCallback } from 'react';
import { useApi } from '../hooks/useApi';
import Paginador from '../components/Paginador';
import { squareImage, originBase } from '../events/util';

const INK = '#9A9A9A';

export default function Puntos() {
  const api = useApi();
  const [tab, setTab] = useState('config');
  // Cuántos premios físicos están esperando que alguien los entregue: va en la solapa,
  // que es lo único que se mira sin entrar.
  const [pendientes, setPendientes] = useState(0);
  useEffect(() => {
    api.get('/api/points/canjes?estado=pendientes')
      .then(r => setPendientes((Array.isArray(r) ? r : []).filter(c => c.tipo !== 'cupon').length))
      .catch(() => {});
  }, []); // eslint-disable-line
  return (
    <div className="lb-fade">
      <div className="lb-display" style={{ fontSize: 24, marginBottom: 4 }}>Sistema de puntos</div>
      <div className="lb-subtabs" style={{ margin: '14px 0 22px' }}>
        <button className={tab === 'config' ? 'active' : ''} onClick={() => setTab('config')}>Configuración</button>
        <button className={tab === 'catalogo' ? 'active' : ''} onClick={() => setTab('catalogo')}>Catálogo</button>
        <button className={tab === 'canjes' ? 'active' : ''} onClick={() => setTab('canjes')}>
          Canjes{pendientes > 0 ? ` (${pendientes})` : ''}
        </button>
        <button className={tab === 'usuarios' ? 'active' : ''} onClick={() => setTab('usuarios')}>Usuarios</button>
      </div>
      {tab === 'config' && <Config api={api} />}
      {tab === 'catalogo' && <Catalogo api={api} />}
      {tab === 'canjes' && <Canjes api={api} onPendientes={setPendientes} />}
      {tab === 'usuarios' && <Usuarios api={api} />}
    </div>
  );
}

function Config({ api }) {
  const [ppt, setPpt] = useState('1');
  const [saved, setSaved] = useState(false);
  useEffect(() => { api.get('/api/points/config').then(c => setPpt(String(c.points_per_thousand))).catch(() => {}); }, []); // eslint-disable-line
  async function save() { try { await api.put('/api/points/config', { points_per_thousand: +ppt || 0 }); setSaved(true); setTimeout(() => setSaved(false), 2000); } catch (e) { alert(e.message); } }
  const ejemplo = Math.floor((12000 / 1000) * (+ppt || 0));
  return (
    <div style={{ maxWidth: 520 }}>
      <div className="lb-card" style={{ padding: '22px 24px' }}>
        <div className="lb-field"><div className="lb-label">Puntos por cada $1.000 gastado</div>
          <input className="lb-input" inputMode="numeric" value={ppt} onChange={e => setPpt(e.target.value.replace(/[^\d.]/g, ''))} />
        </div>
        <div style={{ fontSize: 13, color: INK, margin: '14px 0' }}>Con {ppt || 0}, una compra de $12.000 suma <b style={{ color: 'var(--red-400)' }}>{ejemplo} puntos</b>.</div>
        <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={save}>Guardar</button>
        {saved && <span style={{ color: '#2ecc71', fontSize: 12, marginLeft: 10 }}>Guardado ✓</span>}
      </div>
    </div>
  );
}

function Catalogo({ api }) {
  const [items, setItems] = useState([]);
  // Un solo formulario para todo: null = cerrado, {} = premio nuevo, premio = editar.
  // Antes el alta era una fila de la tabla (nombre, descripción, puntos, stock) y la foto
  // y los talles se cargaban después, en otra ventana: cargar un premio eran dos pasos.
  const [editando, setEditando] = useState(null);
  const load = () => api.get('/api/points/catalog').then(setItems).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line
  async function rm(id) { try { await api.del(`/api/points/catalog/${id}`); load(); } catch (e) { alert(e.message); } }
  async function toggle(it) { try { await api.patch(`/api/points/catalog/${it.id}`, { active: !it.active, stock: it.unlimited ? null : it.stock }); load(); } catch (e) { alert(e.message); } }

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap', marginBottom: 14 }}>
        <div style={{ fontSize: 13, color: INK }}>Los premios activos se muestran en tu web para que la gente sepa qué puede canjear.</div>
        <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={() => setEditando({})}>+ Agregar premio</button>
      </div>
      <div className="lb-card" style={{ padding: '6px 22px' }}>
        <div className="lb-row lb-th" style={{ gridTemplateColumns: '1.3fr 1.6fr 0.9fr 0.8fr 0.6fr 28px' }}>
          <span>Premio</span><span>Descripción</span><span>Puntos</span><span>Stock</span><span>Estado</span><span></span>
        </div>
        {items.map(it => {
          const vars = Array.isArray(it.variants) ? it.variants : [];
          return (
          <div key={it.id} className="lb-row" style={{ gridTemplateColumns: '1.3fr 1.6fr 0.9fr 0.8fr 0.6fr 28px' }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
              {/* La miniatura, para reconocer el premio de un vistazo. Si no tiene foto
                  queda un cuadrito vacío que invita a cargarla. */}
              <span onClick={() => setEditando(it)} title="Editar premio" style={{ width: 34, height: 34, flex: 'none', borderRadius: 4, cursor: 'pointer', overflow: 'hidden', background: 'var(--ink-050)', border: '1px solid var(--border)', display: 'grid', placeItems: 'center' }}>
                {it.image_url
                  ? <img src={it.image_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  : <span style={{ fontSize: 13, color: INK }}>＋</span>}
              </span>
              <span>
                <span style={{ color: '#fff', fontWeight: 600, cursor: 'pointer' }} onClick={() => setEditando(it)}>{it.name}</span>
                {vars.length > 0 && (
                  <span style={{ display: 'block', fontSize: 10.5, color: INK }}>
                    {vars.map(v => v.label + (v.stock != null ? ` (${v.stock})` : '')).join(' · ')}
                  </span>
                )}
              </span>
            </span>
            <span style={{ color: INK, fontSize: 13 }}>{it.description}</span>
            <span style={{ color: 'var(--red-400)', fontWeight: 600 }}>{it.points_required}</span>
            <span style={{ color: INK }}>{it.unlimited || it.stock == null ? '∞' : it.stock}</span>
            <button onClick={() => toggle(it)} style={{ background: 'transparent', border: 0, cursor: 'pointer', color: it.active ? '#2ecc71' : INK, fontSize: 18 }}>{it.active ? '●' : '○'}</button>
            <button className="lb-iconbtn" onClick={() => rm(it.id)}>✕</button>
          </div>
          );
        })}
        {items.length === 0 && <div style={{ padding: '18px 0', color: INK, fontSize: 13 }}>Sin premios en el catálogo. Cargá el primero con <b style={{ color: '#fff' }}>+ Agregar premio</b>.</div>}
      </div>
      <div style={{ marginTop: 10, fontSize: 11, color: INK }}>Stock vacío = ilimitado (∞). Tocá un premio para editarlo. El círculo lo activa o lo desactiva en la web.</div>
      {editando && <PremioEditor api={api} premio={editando} onCerrar={() => setEditando(null)} onGuardado={() => { setEditando(null); load(); }} />}
    </div>
  );
}

// El premio completo en una sola ventana: datos, foto y variantes. Se usa igual para
// crear (premio sin id) que para editar, así cargar un premio es un solo paso.
function PremioEditor({ api, premio, onCerrar, onGuardado }) {
  const nuevo = !premio.id;
  const [f, setF] = useState({
    name: premio.name || '',
    description: premio.description || '',
    points_required: premio.points_required != null ? String(premio.points_required) : '',
    stock: premio.stock == null ? '' : String(premio.stock),
    tipo: premio.tipo === 'cupon' ? 'cupon' : 'fisico',
    retiro: premio.retiro || '',
    descuento_pct: premio.descuento_pct != null ? String(premio.descuento_pct) : '100',
    // Un cupón ya cargado sin evento es de los que valían para cualquiera: se respeta.
    evento_id: premio.evento_id || (!premio.id ? '' : (premio.tipo === 'cupon' ? '__todos' : '')),
  });
  const esCupon = f.tipo === 'cupon';
  // Eventos que todavía no pasaron: el cupón se ata a uno, así no se usa en la noche cara.
  const [eventos, setEventos] = useState([]);
  useEffect(() => {
    api.get('/api/events').then(r => {
      const lista = Array.isArray(r) ? r : (r.events || []);
      const hoy = new Date(new Date().toDateString());
      setEventos(lista.filter(e => !e.date || new Date(e.date) >= hoy));
    }).catch(() => {});
  }, []); // eslint-disable-line
  const [foto, setFoto] = useState(premio.image_url || '');
  const [vars, setVars] = useState(Array.isArray(premio.variants) ? premio.variants : []);
  const [guardando, setGuardando] = useState(false);
  const [err, setErr] = useState('');

  async function elegirFoto(file) {
    if (!file) return;
    setErr('');
    // Se recorta CUADRADA (centro) y se comprime, todo en el navegador: una foto de
    // celular son 5 MB y viaja como base64 (33% más). A 800px una foto de premio se
    // ve perfecta y pesa una fracción. Cuadrada porque cada premio se fotografía como
    // sale —vertical, horizontal— y sin recortar la grilla queda despareja.
    try { setFoto(await squareImage(file, 800, 0.8, '#fff')); }
    catch (e) { setErr(e.message || 'No se pudo procesar la imagen'); }
  }

  const setVar = (i, campo, v) => setVars(vs => vs.map((x, n) => (n === i ? { ...x, [campo]: v } : x)));

  async function guardar() {
    if (!f.name.trim()) { setErr('Poné el nombre del premio'); return; }
    if (esCupon && !f.evento_id) { setErr('Elegí para qué evento vale el cupón'); return; }
    setGuardando(true); setErr('');
    const datos = {
      name: f.name.trim(),
      description: f.description.trim(),
      points_required: +f.points_required || 0,
      stock: f.stock === '' ? null : +f.stock,
      image_url: foto || null,
      // Se mandan solo las que tienen etiqueta; el backend igual las sanea.
      variants: vars.filter(v => String(v.label || '').trim()),
      tipo: f.tipo,
      // El retiro y las variantes son cosa del premio físico; el % y el evento, del cupón.
      retiro: esCupon ? '' : f.retiro.trim(),
      descuento_pct: esCupon ? (+f.descuento_pct || 100) : null,
      evento_id: esCupon && f.evento_id && f.evento_id !== '__todos' ? f.evento_id : null,
    };
    if (esCupon) datos.variants = [];
    try {
      if (nuevo) await api.post('/api/points/catalog', datos);
      else await api.patch(`/api/points/catalog/${premio.id}`, datos);
      onGuardado();
    } catch (e) { setErr(e.message); } finally { setGuardando(false); }
  }

  return (
    <div className="lb-modal-backdrop" onClick={onCerrar}>
      <div className="lb-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 460, padding: '24px 26px', maxHeight: '92vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <div>
            <div className="lb-eyebrow">{nuevo ? 'Nuevo premio' : 'Premio'}</div>
            <div className="lb-h" style={{ fontSize: 19, marginTop: 3 }}>{f.name.trim() || (nuevo ? 'Sin nombre' : premio.name)}</div>
          </div>
          <button className="lb-iconbtn" onClick={onCerrar}>✕</button>
        </div>

        {/* Qué clase de premio es: define qué le llega a la persona al canjear. */}
        <div className="lb-field" style={{ marginBottom: 14 }}>
          <div className="lb-label">Tipo de premio</div>
          <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
            {[['fisico', '📦 Retiro físico'], ['cupon', '🎟️ Cupón de descuento']].map(([v, lbl]) => (
              <button key={v} type="button" onClick={() => setF({ ...f, tipo: v })}
                className={'lb-btn lb-btn--sm ' + (f.tipo === v ? 'lb-btn--primary' : 'lb-btn--ghost')} style={{ flex: 1 }}>{lbl}</button>
            ))}
          </div>
          <div style={{ fontSize: 11, color: INK, marginTop: 8, lineHeight: 1.45 }}>
            {esCupon
              ? 'Al canjear se le emite un cupón único, de un solo uso, que aplica al comprar la entrada de cualquier evento.'
              : 'Al canjear recibe un código para mostrar y retirar el premio donde vos le digas.'}
          </div>
        </div>

        <div className="lb-field">
          <div className="lb-label">Nombre</div>
          <input className="lb-input" autoFocus={nuevo} value={f.name} onChange={e => setF({ ...f, name: e.target.value })} placeholder={esCupon ? 'Ej: Entrada sin cargo' : 'Ej: Remera del boliche'} />
        </div>
        <div className="lb-field" style={{ marginTop: 12 }}>
          <div className="lb-label">Descripción</div>
          <input className="lb-input" value={f.description} onChange={e => setF({ ...f, description: e.target.value })} placeholder="Ej: Algodón, estampa del logo" />
        </div>
        <div style={{ display: 'flex', gap: 12, margin: '12px 0 18px' }}>
          <div className="lb-field" style={{ flex: 1 }}>
            <div className="lb-label">Puntos</div>
            <input className="lb-input" inputMode="numeric" value={f.points_required} onChange={e => setF({ ...f, points_required: e.target.value.replace(/\D/g, '') })} placeholder="100" />
          </div>
          <div className="lb-field" style={{ flex: 1 }}>
            <div className="lb-label">Stock</div>
            <input className="lb-input" inputMode="numeric" value={f.stock} onChange={e => setF({ ...f, stock: e.target.value.replace(/\D/g, '') })} placeholder="∞ (vacío = ilimitado)" />
          </div>
        </div>

        {esCupon ? (
          <>
            <div className="lb-field" style={{ marginBottom: 14 }}>
              <div className="lb-label">Para qué evento vale</div>
              <select className="lb-select" value={f.evento_id} onChange={e => setF({ ...f, evento_id: e.target.value })}>
                <option value="">— Elegí el evento —</option>
                {eventos.map(ev => (
                  <option key={ev.id} value={ev.id}>{ev.name}{ev.date ? ' · ' + String(ev.date).slice(0, 10).split('-').reverse().join('/') : ''}</option>
                ))}
                <option value="__todos">Cualquier evento (sin restricción)</option>
              </select>
              <div style={{ fontSize: 11, color: INK, marginTop: 6, lineHeight: 1.45 }}>
                Elegí la noche que querés empujar: el cupón solo sirve para esa. Cuando ese evento pasa, el premio deja de poder canjearse hasta que elijas otro.
              </div>
            </div>
            <div className="lb-field" style={{ marginBottom: 18 }}>
              <div className="lb-label">% de descuento del cupón</div>
              <input className="lb-input" inputMode="numeric" value={f.descuento_pct}
                onChange={e => setF({ ...f, descuento_pct: e.target.value.replace(/\D/g, '').slice(0, 3) })} placeholder="100" />
              <div style={{ fontSize: 11, color: INK, marginTop: 6 }}>
                100% = la entrada le sale gratis. El cupón se usa una sola vez y sobre una entrada.
              </div>
            </div>
          </>
        ) : (
          <div className="lb-field" style={{ marginBottom: 18 }}>
            <div className="lb-label">Dónde lo retira</div>
            <input className="lb-input" value={f.retiro} onChange={e => setF({ ...f, retiro: e.target.value })} placeholder="Ej: En la barra principal, mostrando el código" />
            <div style={{ fontSize: 11, color: INK, marginTop: 6 }}>Se lo mostramos junto al código cuando canjea.</div>
          </div>
        )}

        <div className="lb-label">Foto</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '6px 0 18px' }}>
          <div style={{ width: 84, height: 84, flex: 'none', borderRadius: 6, overflow: 'hidden', background: 'var(--ink-050)', border: '1px solid var(--border)', display: 'grid', placeItems: 'center' }}>
            {foto ? <img src={foto} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  : <span style={{ fontSize: 11, color: INK }}>sin foto</span>}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <label className="lb-btn lb-btn--white lb-btn--sm" style={{ cursor: 'pointer' }}>
              {foto ? 'Cambiar foto' : 'Subir foto'}
              <input type="file" accept="image/*" style={{ display: 'none' }} onChange={e => elegirFoto(e.target.files?.[0])} />
            </label>
            {foto && <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => setFoto('')}>Quitar</button>}
          </div>
        </div>

        {/* Talles y colores son del premio físico: un cupón no tiene variantes. */}
        {!esCupon && (
          <>
            <div className="lb-label">Variantes (talles, colores…)</div>
            <div style={{ fontSize: 11, color: INK, margin: '4px 0 8px', lineHeight: 1.45 }}>
              Dejá el stock vacío si no querés llevar la cuenta de esa variante. Al canjear,
              la persona elige cuál quiere y se descuenta sola.
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {vars.map((v, i) => (
                <div key={i} style={{ display: 'flex', gap: 6 }}>
                  <input className="lb-input" style={{ flex: 1, padding: '8px 10px', fontSize: 13 }} placeholder="Ej: Talle M"
                    value={v.label || ''} onChange={e => setVar(i, 'label', e.target.value)} />
                  <input className="lb-input" style={{ width: 90, padding: '8px 10px', fontSize: 13 }} placeholder="stock" inputMode="numeric"
                    value={v.stock ?? ''} onChange={e => setVar(i, 'stock', e.target.value.replace(/\D/g, ''))} />
                  <button className="lb-iconbtn" onClick={() => setVars(vs => vs.filter((_, n) => n !== i))}>✕</button>
                </div>
              ))}
              <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => setVars(vs => [...vs, { label: '', stock: '' }])}>+ Agregar variante</button>
            </div>
          </>
        )}

        {err && <div className="lb-err" style={{ marginTop: 12 }}>{err}</div>}
        <button className="lb-btn lb-btn--primary lb-btn--block" style={{ marginTop: 18 }} onClick={guardar} disabled={guardando}>
          {guardando ? 'Guardando…' : (nuevo ? 'Crear premio' : 'Guardar cambios')}
        </button>
      </div>
    </div>
  );
}

const POR_PAGINA = 100;

/* ─────────────────────────── CANJES ───────────────────────────
   Lo que la gente pidió con sus puntos. Los físicos hay que entregarlos (y marcarlos);
   los cupones no: se usan solos al comprar, así que se muestran con su estado y sin
   botón, para que nadie los espere en la barra. */
function Canjes({ api, onPendientes }) {
  const [rows, setRows] = useState([]);
  const [estado, setEstado] = useState('pendientes');
  const [q, setQ] = useState('');
  const [cargando, setCargando] = useState(true);
  const [links, setLinks] = useState([]);
  const [nuevoLink, setNuevoLink] = useState('');
  const [verLinks, setVerLinks] = useState(false);

  const cargar = useCallback(() => {
    setCargando(true);
    api.get(`/api/points/canjes?estado=${estado}&q=${encodeURIComponent(q)}`)
      .then(r => {
        const lista = Array.isArray(r) ? r : [];
        setRows(lista);
        if (estado === 'pendientes' && !q) onPendientes(lista.filter(c => c.tipo !== 'cupon').length);
      })
      .catch(() => setRows([]))
      .finally(() => setCargando(false));
  }, [estado, q]); // eslint-disable-line
  useEffect(() => { const t = setTimeout(cargar, q ? 300 : 0); return () => clearTimeout(t); }, [cargar, q]);
  const cargarLinks = () => api.get('/api/points/links').then(r => setLinks(Array.isArray(r) ? r : [])).catch(() => {});
  useEffect(() => { cargarLinks(); }, []); // eslint-disable-line

  async function entregar(c) {
    try { await api.post(`/api/points/canjes/${c.id}/entregar`, {}); cargar(); }
    catch (e) { alert(e.message); }
  }
  async function deshacer(c) {
    if (!window.confirm(`¿Marcar "${c.concept}" como NO entregado?`)) return;
    try { await api.post(`/api/points/canjes/${c.id}/deshacer`, {}); cargar(); }
    catch (e) { alert(e.message); }
  }
  async function crearLink() {
    try { await api.post('/api/points/links', { name: nuevoLink.trim() || 'Puesto' }); setNuevoLink(''); cargarLinks(); }
    catch (e) { alert(e.message); }
  }
  async function bajaLink(l) {
    if (!window.confirm(`¿Dar de baja el link de ${l.name}? Deja de funcionar al instante.`)) return;
    try { await api.del(`/api/points/links/${l.id}`); cargarLinks(); }
    catch (e) { alert(e.message); }
  }

  const fmt = (d) => { try { return new Date(d).toLocaleString('es-AR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', timeZone: 'America/Argentina/Buenos_Aires' }); } catch { return '—'; } };
  const COLS = '1.1fr 1.5fr 1.2fr 0.9fr 1.5fr';

  return (
    <div className="lb-fade">
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', marginBottom: 14 }}>
        <div style={{ display: 'flex', gap: 6 }}>
          {[['pendientes', 'Pendientes'], ['entregados', 'Entregados'], ['todos', 'Todos']].map(([k, l]) => (
            <button key={k} onClick={() => setEstado(k)} className={'lb-btn lb-btn--sm ' + (estado === k ? 'lb-btn--white' : 'lb-btn--ghost')}>{l}</button>
          ))}
        </div>
        <input className="lb-input" style={{ maxWidth: 260, padding: '9px 12px', fontSize: 13 }}
          placeholder="Buscar por código o premio" value={q} onChange={e => setQ(e.target.value)} />
        <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={cargar}>Actualizar</button>
        <button className="lb-btn lb-btn--ghost lb-btn--sm" style={{ marginLeft: 'auto' }} onClick={() => setVerLinks(v => !v)}>
          {verLinks ? 'Ocultar links' : '🔗 Links de control'}
        </button>
      </div>

      {verLinks && (
        <div className="lb-card" style={{ padding: '18px 22px', marginBottom: 16 }}>
          <div className="lb-h" style={{ fontSize: 15 }}>Links de control de entrega</div>
          <p style={{ color: INK, fontSize: 12, margin: '6px 0 14px', lineHeight: 1.5 }}>
            Para quien entrega los premios: entra sin cuenta y ve solo los pendientes, con el nombre, el premio y el código.
            No ve emails, teléfonos ni puntos. Dalo de baja cuando quieras.
          </p>
          <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
            <input className="lb-input" style={{ maxWidth: 240, padding: '9px 12px', fontSize: 13 }} placeholder="Nombre del puesto: Barra 1…"
              value={nuevoLink} onChange={e => setNuevoLink(e.target.value)} onKeyDown={e => e.key === 'Enter' && crearLink()} />
            <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={crearLink}>+ Crear link</button>
          </div>
          {links.map(l => (
            <div key={l.id} className="lb-row" style={{ gridTemplateColumns: '1fr 2fr auto auto', alignItems: 'center' }}>
              <span style={{ color: '#fff', fontWeight: 600, fontSize: 13 }}>{l.name}</span>
              <span style={{ color: INK, fontSize: 12, wordBreak: 'break-all' }}>{originBase()}/premios/{l.token}</span>
              <CopiarLink url={`${originBase()}/premios/${l.token}`} />
              <button className="lb-iconbtn" title="Dar de baja" onClick={() => bajaLink(l)}>✕</button>
            </div>
          ))}
          {links.length === 0 && <div style={{ color: INK, fontSize: 13, padding: '6px 0' }}>Todavía no creaste ninguno.</div>}
        </div>
      )}

      <div className="lb-card tk-scroll-x" style={{ padding: '6px 22px' }}>
        <div className="lb-row lb-th" style={{ gridTemplateColumns: COLS }}>
          <span>Fecha</span><span>Premio</span><span>Persona</span><span>Código</span><span>Estado</span>
        </div>
        {cargando && <div style={{ padding: '18px 0', color: INK, fontSize: 13 }}>Cargando…</div>}
        {!cargando && rows.length === 0 && (
          <div style={{ padding: '18px 0', color: INK, fontSize: 13 }}>
            {estado === 'pendientes' ? 'No hay premios esperando que los entregues. ✓' : 'Sin canjes para este filtro.'}
          </div>
        )}
        {rows.map(c => {
          const cupon = c.tipo === 'cupon';
          const usado = cupon && Number(c.cupon_usos || 0) > 0;
          return (
            <div key={c.id} className="lb-row" style={{ gridTemplateColumns: COLS, alignItems: 'center' }}>
              <span style={{ color: INK, fontSize: 12 }}>{fmt(c.created_at)}</span>
              <span>
                <span style={{ color: '#fff', fontWeight: 600, fontSize: 13 }}>{c.concept}</span>
                <span style={{ display: 'block', fontSize: 11, color: INK }}>
                  {cupon
                    ? `🎟️ Cupón${c.evento_nombre ? ` · ${c.evento_nombre}` : ''}`
                    : `📦 ${c.retiro || 'Retiro en el boliche'}`}
                </span>
              </span>
              <span style={{ color: 'var(--ink-800)', fontSize: 13 }}>{c.persona}</span>
              <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, color: 'var(--red-400)', fontSize: 13 }}>{c.codigo || '—'}</span>
              <span style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                {cupon ? (
                  <span className={'lb-status ' + (usado ? 'lb-status--paid' : 'lb-status--gen')}>{usado ? 'Cupón usado' : 'Sin usar'}</span>
                ) : c.entregado_at ? (
                  <>
                    <span className="lb-status lb-status--paid" title={fmt(c.entregado_at)}>Entregado</span>
                    <span style={{ fontSize: 11, color: INK }}>{c.entregado_por || ''}</span>
                    <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => deshacer(c)}>Deshacer</button>
                  </>
                ) : (
                  <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={() => entregar(c)}>Marcar entregado</button>
                )}
              </span>
            </div>
          );
        })}
      </div>
      <div style={{ marginTop: 10, fontSize: 11, color: INK }}>
        Los cupones no se entregan: la persona los usa al comprar su entrada. Acá se ve si ya los usó.
      </div>
    </div>
  );
}

function CopiarLink({ url }) {
  const [copiado, setCopiado] = useState(false);
  return (
    <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => { navigator.clipboard?.writeText(url); setCopiado(true); setTimeout(() => setCopiado(false), 1500); }}>
      {copiado ? 'Copiado ✓' : 'Copiar'}
    </button>
  );
}

function Usuarios({ api }) {
  const [users, setUsers] = useState([]);
  const [managing, setManaging] = useState(null);
  const [q, setQ] = useState('');
  const [pag, setPag] = useState(1);
  // El catálogo se trae acá para poder elegir el premio al registrar una entrega, y se
  // recarga después de cada canje porque el stock pudo bajar.
  const [catalogo, setCatalogo] = useState([]);
  const cargarCatalogo = () => api.get('/api/points/catalog').then(c => setCatalogo((c || []).filter(x => x.active))).catch(() => {});
  const load = () => api.get('/api/points/users').then(setUsers).catch(() => {});
  useEffect(() => { load(); cargarCatalogo(); }, []); // eslint-disable-line

  // Buscar por nombre o email, sin acentos ni mayúsculas: quien busca "martinez" tiene
  // que encontrar a "Martínez". El rango del replace son las marcas de acento que deja
  // NFD (U+0300 a U+036F); se ven vacías en el editor pero están.
  const norm = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  const filtrados = q.trim()
    ? users.filter(u => norm(u.buyer_name).includes(norm(q)) || norm(u.buyer_email).includes(norm(q)))
    : users;

  // La página vuelve a 1 al buscar: si no, buscás algo con 3 resultados estando en la
  // página 5 y la lista se ve vacía.
  const totalPaginas = Math.max(1, Math.ceil(filtrados.length / POR_PAGINA));
  const paginaActual = Math.min(pag, totalPaginas);
  const desde = (paginaActual - 1) * POR_PAGINA;
  const pagina = filtrados.slice(desde, desde + POR_PAGINA);

  return (
    <div>
      {managing && <Manage api={api} user={managing} catalogo={catalogo} onClose={() => { setManaging(null); load(); }} onCambio={cargarCatalogo} />}

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap', marginBottom: 14 }}>
        <input className="lb-input" style={{ maxWidth: 320, flex: 1, minWidth: 200 }}
          placeholder="Buscar por nombre o email"
          value={q} onChange={e => { setQ(e.target.value); setPag(1); }} />
        <div style={{ fontSize: 12.5, color: INK }}>
          {filtrados.length === users.length
            ? `${users.length} ${users.length === 1 ? 'usuario' : 'usuarios'}`
            : `${filtrados.length} de ${users.length}`}
          {totalPaginas > 1 && ` · mostrando ${desde + 1}–${Math.min(desde + POR_PAGINA, filtrados.length)}`}
        </div>
      </div>

      <div className="lb-card" style={{ padding: '6px 22px' }}>
        <div className="lb-row lb-th" style={{ gridTemplateColumns: '1.4fr 1.8fr 0.8fr 0.8fr' }}>
          <span>Cliente</span><span>Email</span><span>Puntos</span><span></span>
        </div>
        {pagina.map(u => (
          <div key={u.id} className="lb-row" style={{ gridTemplateColumns: '1.4fr 1.8fr 0.8fr 0.8fr' }}>
            <span style={{ color: '#fff', fontWeight: 600 }}>{u.buyer_name || '—'}</span>
            <span style={{ color: INK, fontSize: 13 }}>{u.buyer_email}</span>
            <span style={{ color: 'var(--red-400)', fontWeight: 700 }}>{u.points}</span>
            <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => setManaging(u)}>Gestionar</button>
          </div>
        ))}
        {users.length === 0 && <div style={{ padding: '20px 0', textAlign: 'center', color: INK, fontSize: 13 }}>Sin usuarios con puntos todavía.</div>}
        {users.length > 0 && filtrados.length === 0 && (
          <div style={{ padding: '20px 0', textAlign: 'center', color: INK, fontSize: 13 }}>Nadie coincide con “{q}”.</div>
        )}
      </div>

      <Paginador actual={paginaActual} total={totalPaginas} onIr={setPag} />
    </div>
  );
}

function Manage({ api, user, catalogo, onClose, onCambio }) {
  const [hist, setHist] = useState([]);
  const [concept, setConcept] = useState('');
  const [premioId, setPremioId] = useState('');
  const [variante, setVariante] = useState('');
  const [spent, setSpent] = useState('');
  const load = () => api.get(`/api/points/users/${encodeURIComponent(user.buyer_email)}/history`).then(setHist).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line
  const variantesDe = (id) => {
    const c = (catalogo || []).find(x => x.id === id);
    return Array.isArray(c?.variants) ? c.variants : [];
  };

  async function redeem() {
    if (!premioId && !concept.trim()) return;
    // Si el premio tiene variantes, no se registra sin elegir cuál: sin eso el stock por
    // talle nunca baja y la remera L figura disponible para siempre.
    if (premioId && variantesDe(premioId).length && !variante) { alert('Elegí qué variante entregaste.'); return; }
    try {
      await api.post(`/api/points/users/${encodeURIComponent(user.buyer_email)}/redeem`,
        premioId
          ? { catalog_id: premioId, variant_label: variante || null }
          : { concept, points_spent: +spent || 0 });
      setConcept(''); setSpent(''); setPremioId(''); setVariante('');
      load(); onCambio && onCambio();
    } catch (e) { alert(e.message); }
  }
  async function reset() {
    if (!window.confirm('¿Resetear los puntos de este cliente a 0?')) return;
    try { await api.post(`/api/points/users/${encodeURIComponent(user.buyer_email)}/reset`); onClose(); } catch (e) { alert(e.message); }
  }
  return (
    <div className="lb-modal-backdrop" onClick={onClose}>
      <div className="lb-modal" onClick={e => e.stopPropagation()}>
        <div style={{ padding: '20px 24px', borderBottom: '1px solid rgba(255,255,255,0.08)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div><div className="lb-h" style={{ fontSize: 18 }}>{user.buyer_name || user.buyer_email}</div><div style={{ fontSize: 12, color: INK }}>{user.buyer_email} · <b style={{ color: 'var(--red-400)' }}>{user.points} pts</b></div></div>
          <button className="lb-iconbtn" onClick={onClose}>✕</button>
        </div>
        <div style={{ padding: '20px 24px' }}>
          <div className="lb-eyebrow" style={{ marginBottom: 10 }}>Registrar premio entregado</div>
          {/* Se elige el premio del catálogo en vez de escribirlo: así los puntos salen
              del catálogo (dos canjes del mismo premio no pueden descontar distinto), se
              registra QUÉ variante se entregó, y el stock baja solo. Queda "Otro" para
              lo que no está en el catálogo, que era el único modo de antes. */}
          <div style={{ display: 'flex', gap: 8, marginBottom: 10, flexWrap: 'wrap' }}>
            <select className="lb-select" style={{ flex: 1, minWidth: 180 }} value={premioId}
              onChange={e => { setPremioId(e.target.value); setVariante(''); }}>
              <option value="">Otro (escribir a mano)</option>
              {(catalogo || []).map(c => (
                <option key={c.id} value={c.id}>{c.name} · {c.points_required} pts</option>
              ))}
            </select>
            {variantesDe(premioId).length > 0 && (
              <select className="lb-select" style={{ width: 160 }} value={variante} onChange={e => setVariante(e.target.value)}>
                <option value="">Elegí variante</option>
                {variantesDe(premioId).map(v => (
                  <option key={v.label} value={v.label} disabled={v.stock === 0}>
                    {v.label}{v.stock != null ? ` (${v.stock})` : ''}
                  </option>
                ))}
              </select>
            )}
          </div>
          <div style={{ display: 'flex', gap: 8, marginBottom: 18 }}>
            {!premioId && <>
              <input className="lb-input" placeholder="Concepto (ej: remera, trago, entrada)" value={concept} onChange={e => setConcept(e.target.value)} />
              <input className="lb-input" style={{ width: 110 }} placeholder="Puntos" inputMode="numeric" value={spent} onChange={e => setSpent(e.target.value.replace(/\D/g, ''))} />
            </>}
            <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={redeem} disabled={!premioId && !concept.trim()}>Registrar entrega</button>
          </div>
          <div className="lb-eyebrow" style={{ marginBottom: 10 }}>Historial</div>
          <div style={{ maxHeight: 220, overflowY: 'auto' }}>
            {hist.map((h, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.06)', fontSize: 13 }}>
                <span style={{ color: '#fff' }}>{h.concept}
                  {/* El código que canjeó el cliente desde su cuenta: es lo que muestra en
                      la barra para retirar el premio. */}
                  {h.codigo && <span style={{ color: 'var(--red-300)', fontSize: 12 }}> · código {h.codigo}</span>}</span>
                <span style={{ color: h.points_added > 0 ? '#2ecc71' : 'var(--red-400)' }}>{h.points_added > 0 ? '+' + h.points_added : '-' + h.points_spent}</span>
              </div>
            ))}
            {hist.length === 0 && <div style={{ color: INK, fontSize: 13, padding: '8px 0' }}>Sin movimientos.</div>}
          </div>
          <button className="lb-btn lb-btn--ghost lb-btn--block" style={{ marginTop: 18, borderColor: 'rgba(139,15,26,0.5)', color: 'var(--red-300)' }} onClick={reset}>Resetear puntos a 0</button>
        </div>
      </div>
    </div>
  );
}
